import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { SupplierDirectoryLab } from 'models/supplier-request';

/** DD-3662: what a supplier's "Other" service means, in its profile. */
const SupplierOtherService: FC<{ lab: SupplierDirectoryLab }> = ({ lab }) => {
    const { t: translate } = useTranslation(['client-directory']);
    if (!lab.otherService) return null;
    return (
        <Typography variant="body2" color="text.secondary" mt={1}>
            {translate('client-directory:SUPPLIER_OTHER_SERVICES', { services: lab.otherService })}
        </Typography>
    );
};

export default SupplierOtherService;
